<template>
	<!-- 登录 弹窗开始-->
	<div class="loginWap" >
	  <div class="out">
	    <div class="inner">
	      <img src="/images/login.png" class="loginImg"/>
	      <div class="loginForm">
	        <img src="/images/rightClose.png" @click="closeFloat()" class="closePop2"/>
	        <ul class="tab1">
	          <li id="a1" @click="changePanel(0,'登录页-微信登录-点击')" :class="activePanel==0?'curr':''"><span>微信登录</span></li>
	          <li id="a2" @click="changePanel(1,'登录页-账号密码登录-点击')" :class="activePanel==1?'curr':''"><span>账号密码登录</span></li>
	          <li id="a3" @click="changePanel(2,'登录页-手机号登录-点击')" :class="activePanel==2?'curr':''"><span>手机号登录</span></li>
	        </ul>
	        <div v-show="activePanel==0" id="con_a_1">
	          <div class="codeWap">
							<div style="position: relative;" v-loading="wxqrcodeloading">
								<img v-bind:src="wxqrcode" style="width: 240px;height: 240px;margin: 30px"/>
								<div style="position: absolute;top: 0px;width: 304px;height: 300px;background-color: rgba(255,255,255,0.9);" v-show="wxqrcodecount>=20" @click="getQrCode()">
									<div style="margin-top: 130px;font-weight: bold;">二维码超时失效<br />请点击刷新！</div>
								</div>
							</div>
	            <p style=" margin-bottom:15px">打开微信扫一扫，快捷登录/注册</p>
	            <img src="/images/line02.png"/>
	            <div v-show="jtLoginButtonVisible" @click="jtLoginFunc" class="qBtn">{{jtLoginButtonText}}</div>
	            <div class="loginFotter">未注册用户扫码后自动登录，登录即代表<br/>同意<a href="/pdf/Service Agreement.pdf" target="_blank">《服务协议》</a>与<a href="/pdf/Privacy Agreement.pdf" target="_blank">《隐私协议》</a></div>
	          </div>
	        </div>
	        <div v-show="activePanel==1" id="con_a_2">
	          <div class="accountWap">
	            <dl>
	              <!-- <dt>账号</dt> -->
	              <dd><input v-model="loginform.account" type="text" placeholder="手机号/用户名/邮箱"/></dd>
	              <!-- <dt>密码</dt> -->
	              <dd><input v-model="loginform.password" type="password" placeholder="密码"/></dd>
								<dd v-show="accountImgCodeVisible">
								  <input v-model="loginform.imgcode" type="text" placeholder="图片验证码（区分大小写）"/>
								  <img v-bind:src="accountImgCodeSrc" @click="changeAccountImgCode()" class="imgcoderadius"/>
								</dd>
	              <dd><input v-model="savepassword" type="checkbox"/>下次自动登录<a @click="jumptowjmm()">忘记密码?</a></dd>
	            </dl>
							<div class="accountLoginBtn">
								<input @click="changePanel(2,'登录页-手机号登录-点击')" type="button" value="注册" class="loginBtn registBtn"/>
								<input v-show="accountLoginButtonVissible" :disabled="accountLoginButtonDisable" @click="accountLoginFunc" type="button" :value="accountLoginButtonText" class="loginBtn"/>
							</div>
	            <div v-show="jtLoginButtonVisible" @click="jtLoginFunc" class="qBtn">{{jtLoginButtonText}}</div>
	            <div class="loginFotter">登录即代表同意<a href="/pdf/Service Agreement.pdf" target="_blank">《服务协议》</a>与<a href="/pdf/Privacy Agreement.pdf" target="_blank">《隐私协议》</a></div>
	          </div>
	        </div>
	        <div v-show="activePanel==2" id="con_a_3">
	          <div class="accountWap" style="margin-top: -10px">
	            <dl>
	              <!-- <dt>手机号</dt> -->
	              <dd><input v-model="phoneform.phone" type="text" placeholder="手机号"/></dd>
	              <!-- <dt>图片验证码</dt> -->
	              <dd>
	                <input v-model="phoneform.imgcode" type="text" placeholder="图片验证码（区分大小写）"/>
	                <img v-bind:src="phoneImgCodeSrc" @click="changePhoneImgCode()" class="imgcoderadius"/>
	              </dd>
	              <!-- <dt>验证码</dt> -->
	              <dd>
									<input v-model="phoneform.verifycode" type="text" placeholder="验证码"/>
									<input @click="sendPWDCode" :disabled="pwdcountdown>0" type="button" :value="pwdcountdown?pwdcountdown:'发送验证码'" :class="phonecountdown>0?'un':'sendBtn'" />
								</dd>
	            </dl>
	            <input @click="phoneLoginFunc()" type="button" value="登录/注册" class="loginBtn" style="margin-top: 37px"/>
	            <div v-show="jtLoginButtonVisible" @click="jtLoginFunc" class="qBtn" style="margin-top: 0">{{jtLoginButtonText}}</div>
	            <div class="loginFotter" style="margin-top: 30px">未注册用户扫码后自动登录，登录即代表<br/>同意<a href="/pdf/Service Agreement.pdf" target="_blank">《服务协议》</a>与<a href="/pdf/Privacy Agreement.pdf" target="_blank">《隐私协议》</a></div>
	          </div>
	        </div>
	      </div>
	    </div>
	  </div>    
	</div>
</template>

<script>
	import md5 from 'js-md5';
	export default {
		data() {
			return {
				baseurl: "",
				preloginurl:'',
				loginToken: '1111',
				ssotoken: "1111",
				bid: "12312312312",
				appid: "10011018",
				globalappid: "",
				lgtk: "111",
				wjid: "",
				lbmain: "",
				sendlostcode: false,
				tt: 0,
				wjmmurl:'/',


				activePanel: 0,
				loginform: {
					account: '',
					password: '',
					imgcode: ''
				},
				phoneform: {
					phone: '',
					imgcode: '',
					verifycode: '',
				},
				savepassword: false,
				wxqrcodecount:0,
				wxqrcodeid:'',
				wxqrcode: '',
				wxqrcodeloading: false,
				jtLoginButtonVisible: false,
				jtLoginButtonText: '集团用户快捷入口',
				accountImgCodeVisible: false,
				accountImgCodeSrc: '',
				accountLoginButtonVissible: true,
				accountLoginButtonDisable: false,
				accountLoginButtonText: '登录',
				phoneImgCodeSrc: '',
				pwdcountdown:0,
				pwdpasskeyword:'key241015',
			}
		},
		mounted() {
			if(this.$cookies.get('pwdcountdown')&&parseInt(this.$cookies.get('pwdcountdown'))){
				this.setCountdown(parseInt(this.$cookies.get('pwdcountdown')));
			}
			this.getLoginBaseInfo();
			// this.getQrCode();
			// this.changePhoneImgCode();
			// this.getLoginHelper();
			// this.autoLogin();
			// this.loadJT();
		},
		methods: {
			changePanel: function(active,type) {
				this.activePanel=active;
				this.$track([
					['pagetype',type],
				]);
			},
			getLoginBaseInfo:function(){
				let _this = this;
				this.$http({
						method: 'get',
						url: 'getBaseInfo',
						responseType: 'json',
						params: {
						},
					})
					.then(function(response){
						if(response.data.code==20000){
							_this.baseurl=response.data.data.data.baseurl;
							_this.appid=response.data.data.data.appid;
							_this.bid=response.data.data.data.bid;
							_this.loginToken=response.data.data.data.loginToken;
							_this.ssotoken=response.data.data.data.ssotoken;
							_this.wjmmurl=response.data.data.data.wjmmurl;
							// debugger;
							// _this.preloginurl=_this.baseurl+'/Action/DoView.ashx?view=temp';
							_this.getPassBaseCookie();
							// _this.getQrCode();
							// _this.changePhoneImgCode();
							// _this.getLoginHelper();
							// _this.autoLogin();
							// _this.loadJT();
						}
						else{
							_this.$alert(
								'获取登录参数失败，请刷新页面重试！',
								'提示信息', {
									confirmButtonText: '确定'
								},
							);
						}
					})
			},
			getPassBaseCookie:function(){
				let _this = this;
				this.$https({
						method: 'get',
						url: this.baseurl + '/Action/DoView.ashx?view=temp',
						params: {
						}
					})
					.then(function(response){
						_this.getQrCode();
						_this.changePhoneImgCode();
						_this.getLoginHelper();
						_this.autoLogin();
						_this.loadJT();
					})
					.catch(function(error) {
						_this.getQrCode();
						_this.changePhoneImgCode();
						_this.getLoginHelper();
						_this.autoLogin();
						_this.loadJT();
					});
			},
			getLoginHelper: function() {
				let _this = this;
				this.$https({
						method: 'post',
						url: this.baseurl + '/Action/DoAction.ashx?method=GetSSOLogState&cls=LoginHelper',
						params: {
							pnum: "-1",
							PublicToken: "-1",
							ssotk: this.ssotoken,
							bid: this.bid,
							otmsg: "1"
						}
					})
					.then(function(response) {
						// debugger;
						_this.$https({
								method: 'post',
								url: _this.baseurl + '/Action/DoAction.ashx?method=lgRoboot&cls=LoginHelper',
								params: {
									loginToken: _this.loginToken,
									bid: _this.bid
								}
							})
							.then(function(response) {
								// debugger;
								if (response.data == "1") {
									_this.changeAccountImgCode();
									_this.accountImgCodeVisible = true;
								}
							})
							.catch(function(error) {
								console.log(error);
							});

						var backarr = response.data.split('Σ');
						var text = backarr[0];
						var token = backarr[2];
						_this.tt = parseInt(token);
						if (text == "-1") {
							if (_this.tt > 3) {
								_this.accountImgCodeVisible = true;
							}
							if (backarr.length > 3) {
								var otms = backarr[3];
								if (otms.length > 0) {
									var tipsms = otms.split("_");
									if (tipsms[1].length == 0) {
										_this.$alert(
											'您的账号在其他地方登录，如非本人操作，请及时修改密码。',
											'提示信息', {
												confirmButtonText: '确定'
											},
										);
									} else {
										_this.$alert(
											'您上次登录被踢出，踢出登录地址为：' + tipsms[1] + '，如非本人操作，请及时修改密码。',
											'提示信息', {
												confirmButtonText: '确定'
											},
										);
									}
								}
							}
						} else {
							if (text == "ok") {
								var arrtext = textback.split('Σ');
								window.location.href=arrtext[1];
							} else {
								if (_this.tt > 3) {
									_this.accountImgCodeVisible = true;
								}
							}
						}
					});
			},
			autoLogin: function() {
				var loginTokenCookies = this.$cookies.get('autologintoken');
				if (loginTokenCookies != undefined) {
					this.accountLoginButtonVissible = false;
					this.accountLoginButtonText = '登录中...';
					let _this = this;
					this.$https({
							method: 'post',
							url: this.baseurl + '/Action/DoAction.ashx?method=SsoAutoLogin&cls=LoginHelper',
							params: {
								loginToken: loginTokenCookies,
								"ssotk": this.ssotoken,
								bid: this.bid,
								appid: this.appid
							}
						})
						.then(function(response) {
							// debugger;
							var text = response.data.split('Σ')[0];
							var arrtext = response.data.split('Σ');
							if (text == "ok") {
								if (arrtext[3] != null && arrtext[3].length > 0) {
									_this.$alert(arrtext[3], '提示信息', {
										confirmButtonText: '确定',
										callback: function(action) {
											window.location.href=arrtext[1];
										}
									});
								} else {
									window.location.href=arrtext[1];
								}
							} else {
								_this.accountLoginButtonVissible = true;
								_this.accountLoginButtonText = '登录';
							}
						})
						.catch(function(error) {
							_this.accountLoginButtonVissible = true;
							_this.accountLoginButtonText = '登录';
						});
				}
			},
			loadJT: function() {
				let _this = this;
				this.$https({
						method: 'post',
						url: this.baseurl + '/Action/DoAction.ashx?method=getJTDLnologin&cls=LoginHelper',
						params: {
							pnum: "-1",
							PublicToken: "-1",
							ssotk: this.ssotoken,
							bid: this.bid,
							lgtk: this.lgtk,
							appid: this.globalappid
						}
					})
					.then(function(response) {
						// debugger;
						var text = response.data.split('Σ')[0];
						if (text == "ok") {
							_this.jtLoginButtonVisible = true;
							// $("#jttips").show();
							// $("#jttips").animate({
							// 	height: '25px'
							// }, 600);
							// if (_this.globalappid == "10011007" || _this.globalappid == "10011009" || _this.globalappid == "10011001") {
							// 	_this.jtLoginButtonText=response.data.split('Σ')[3] + "集团用户快捷入口";
							// $("#jtrk").attr('value', response.data.split('Σ')[3] + "集团用户快捷入口")
							// $("#jtrk").removeClass("login_jt");
							// $("#jtrk").addClass("logingl_jt");
							// } else {
							_this.jtLoginButtonText = response.data.split('Σ')[3] + "集团用户快捷入口";
							// }
						} else {

						}
					})
			},
			jtLoginFunc: function() {
				this.$track([
					['pagetype','登录页-集团登录-点击'],
				]);
				// debugger;
				let _this = this;
				this.$https({
						method: 'post',
						url: this.baseurl + '/Action/DoAction.ashx?method=getJTDL&cls=LoginHelper',
						params: {
							pnum: "-1",
							PublicToken: "-1",
							ssotk: this.ssotoken,
							bid: this.bid,
							lgtk: this.lgtk,
							appid: this.appid
						}
					})
					.then(function(response) {
						// debugger;
						var text = response.data.split('Σ')[0];
						if (text == "ok") {
							var arr = response.data.split('Σ');
							_this.jtLoginPost(arr[1], "XMLResponse", arr[2]);
						} else {
							if (text == "no") {
								_this.$alert('您非IP集团用户！', '提示信息', {
									confirmButtonText: '确定',
								});
							} else {
								_this.$alert(text, '提示信息', {
									confirmButtonText: '确定',
								});
							}
							return false;
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			jtLoginPost: function(URL, pname, pvalue) {
				//创建form表单
				var temp_form = document.createElement("form");
				temp_form.action = URL;
				//如需打开新窗口，form的target属性要设置为'_blank'
				temp_form.target = "_self";
				temp_form.method = "post";
				temp_form.style.display = "none";
				//添加参数

				var opt = document.createElement("textarea");
				opt.name = pname;
				opt.value = pvalue;
				temp_form.appendChild(opt);

				document.body.appendChild(temp_form);
				//提交数据
				temp_form.submit();
			},
			accountLoginFunc: function() {
				debugger;
				if (this.tt > 3) {
					if (!this.loginform.imgcode) {
						this.$alert('请输入验证码!', '提示信息', {
							confirmButtonText: '确定',
						});
						return false;
					}
				}
				if ((!this.loginform.account) || (!this.loginform.password)) {
					this.$alert('请输入用户名或密码!', '提示信息', {
						confirmButtonText: '确定',
					});
					return false;
				}
				this.accountLoginButtonDisable = true;
				this.accountLoginButtonText = '登录中...';
				debugger;
				var pwt = -1;
				pwt = this.pfw(this.loginform.password, this.loginform.account);
				var isAutoLogin = this.savepassword;
				let _this = this;
				this.$https({
						method: 'post',
						url: this.baseurl + '/Action/DoAction.ashx?method=LoginCheckPwdSSO&cls=LoginHelper',
						params: {
							name: this.loginform.account,
							pwd: md5(this.loginform.password),
							PublicToken: 1,
							imgcode: this.loginform.imgcode,
							ssotk: this.ssotoken,
							autologin: isAutoLogin,
							bid: this.bid,
							lgtk: this.lgtk,
							appid: this.appid,
							wjid: this.wjid,
							pwt: pwt
						}
					})
					.then(function(response) {
						debugger;
						_this.$cookies.set('username', _this.loginform.account, '7d');
						var text = response.data.split('Σ')[0];
						var arrtext = response.data.split('Σ');
						if (text == "ok") {
							if(_this.savepassword){
								_this.$cookies.set('autologintoken', md5(_this.loginform.account+_this.appid), '10d');
							}
							if (isNameInPwd(_this.loginform.account, _this.loginform.password) || isInweek(_this
									.loginform.password)) {
								if (arrtext[3].length > 0) {
									_this.$alert(arrtext[3], '提示信息', {
										confirmButtonText: '确定',
										callback: function(action) {
											window.location.href=arrtext[1];
										}
									});
								} else {
									window.location.href=arrtext[1];
								}
							} else {
								if (arrtext[3].length > 0) {
									_this.$alert(arrtext[3], '提示信息', {
										confirmButtonText: '确定',
										callback: function(action) {
											window.location.href=arrtext[1];
										}
									});
								} else {
									window.location.href=arrtext[1];
								}
							}
						} else {
							if (text.indexOf("修改密码") > 0) {
								_this.$confirm(text, '提示信息', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									type: 'warning'
								}).then(() => {
									window.location.href = _this.baseurl+"/DoView.ashx?view=Wjmm&dt=" +
										_this.generateMixed(10) + "&appid=" + _this.appid + "&lgtk=" + _this.lgtk +
										"&wjid=" + _this.wjid;
								}).catch(() => {
									// window.location.href = _this.baseurl+"/DoView.ashx?view=quyulogin&SSOtoken=" +
									// 	_this.ssotoken + "&dt=" + _this.generateMixed(10) + "&appid=" + _this.appid +
									// 	"&lgtk=" + _this.lgtk + "&wjid=" + _this.wjid;         
									window.location.reload();
								});
							} else {
								_this.$alert(text, '提示信息', {
									confirmButtonText: '确定',
									callback: function(action) {
										// window.location.href = _this.baseurl+"/DoView.ashx?view=quyulogin&SSOtoken=" +
										// 	_this.ssotoken + "&dt=" + _this.generateMixed(10) + "&appid=" + _this.appid +
										// 	"&lgtk=" + _this.lgtk + "&wjid=" + _this.wjid;
										window.location.reload();
									}
								});
							}
						}
						_this.accountLoginButtonDisable = false;
						_this.accountLoginButtonText = '登录';
					})
					.catch(function(error) {
						_this.accountLoginButtonDisable = false;
						_this.accountLoginButtonText = '登录';
						console.log(error);
					});
			},
			setCountdown:function(num){
				let _this = this;
				_this.pwdcountdown=num;
				clearInterval(_this.pwdtimer);
				_this.pwdtimer=setInterval(function(){
					// debugger;
					if(_this.pwdcountdown>1){
						_this.pwdcountdown--;
						_this.$cookies.set('pwdcountdown',_this.pwdcountdown,_this.pwdcountdown);
					}
					else{
						_this.pwdcountdown=0;
						clearInterval(_this.pwdtimer);
						_this.$cookies.remove('pwdcountdown');
					}
				},1000);
			},
			sendPWDCode:function(){
				let _this = this;
				if(this.pwdcountdown>0){
					this.$alert('不可频繁发送验证码', '提示信息', {
						confirmButtonText: '确定',
					});
					return false;
				}
				if(!(this.phoneform.phone&&this.checkisPhone(this.phoneform.phone))){
					this.$alert('请填写正确的手机号', '提示信息', {
						confirmButtonText: '确定',
					});
					return false;
				}
				if(!this.phoneform.imgcode){
					this.$alert('请填写图片验证码', '提示信息', {
						confirmButtonText: '确定',
					});
					return false;
				}
				this.pwdcountdown=60;
				this.$http({
						method: 'post',
						url: 'getPhoneCodeInfo',
						responseType: 'json',
						params: {
							Mobile:this.phoneform.phone,
							CheckCode: this.phoneform.imgcode,
							PassKey:md5(this.phoneform.phone+this.phoneform.imgcode+this.pwdpasskeyword),
						},
					})
					.then(function(response) {
						if(response.data.code==20000){
							_this.$message({
								message: response.data.data.msg,
								type: 'success'
							});
							_this.setCountdown(60);
						}
						else{
							_this.$alert(response.data.data.msg, '提示信息', {
								confirmButtonText: '确定',
							});
							_this.pwdcountdown=0;
						}
					})
					.catch(function(error) {
						_this.$alert('发送失败', '提示信息', {
							confirmButtonText: '确定',
						});
						_this.pwdcountdown=0;
						console.log(error);
					});
			},
			phoneLoginFunc:function(){
				if(!(this.phoneform.phone&&this.checkisPhone(this.phoneform.phone))){
					this.$alert('请填写正确的手机号', '提示信息', {
						confirmButtonText: '确定',
					});
					return false;
				}
				if(!this.phoneform.verifycode){
					this.$alert('请填写手机验证码', '提示信息', {
						confirmButtonText: '确定',
					});
					return false;
				}
				let _this = this;
				this.$http({
						method: 'post',
						url: 'DTLoginByMobile',
						responseType: 'json',
						params: {
							Mobile: this.phoneform.phone,
							// CheckCode:this.phoneform.imgcode,
							MobileCheckCode:this.phoneform.verifycode,
						},
					})
					.then(function(response) {
						if(response.data.code==20000){
							_this.$message({
								message: response.data.data.msg,
								type: 'success'
							});
							window.location.reload();
						}
						else{
							_this.$alert(response.data.data.msg, '提示信息', {
								confirmButtonText: '确定',
							});
						}
					})
					.catch(function(error) {
						_this.$alert('登录失败', '提示信息', {
							confirmButtonText: '确定',
						});
						console.log(error);
					});
			},
			getQrCode: function() {
				let _this = this;
				_this.wxqrcodeloading = true;
				this.$http({
						method: 'get',
						url: 'getWXQr',
						// responseType: 'json',
						params: {

						},
					})
					.then(function(response) {
						_this.wxqrcodeid = response.data.data.data.parameter;
						_this.wxqrcode = response.data.data.data.qrCode;
						_this.wxqrcodeloading = false;
						_this.wxqrcodecount=0;
						setTimeout(function(){_this.checkQrLogin()},3000);
					})
					.catch(function(error) {
						_this.wxqrcodeloading = false;
						console.log(error);
					});
			},
			checkQrLogin:function(){
				this.wxqrcodecount++;
				if(this.wxqrcodecount>=20){
					return false;
				}
				let _this = this;
				this.$http({
						method: 'get',
						url: 'refreshUserID',
						// responseType: 'json',
						params: {
							scene:this.wxqrcodeid
						},
					})
					.then(function(response) {
						if(response.data.code==20000){
							_this.$message({
								message: '登录成功',
								type: 'success'
							});
							window.location.reload();
						}
						else{
							setTimeout(function(){_this.checkQrLogin()},3000);
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			changeAccountImgCode: function() {
				this.accountImgCodeSrc = this.baseurl+ '/Action/ValidateCode.ashx?dt=' + this.bid;
			},
			changePhoneImgCode: function() {
				this.phoneImgCodeSrc = (process.env.NODE_ENV === 'development' ? '/proxyapi/' : '/') + 'Captcha?' +
					new Date().getTime();
			},
			jumptowjmm:function(){
				window.location.href =this.wjmmurl;
			},
			pfw: function(pd, ac) {
				debugger;
				if (pd.length == 0) {
					return 0;
				}
				if (pd.length < 8) {
					return 1;
				}
				var pnum = ac
				var strongRegex = new RegExp("^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$", "g");
				var mediumRegex = new RegExp(
					"^(?=.{7,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$",
					"g");
				var enoughRegex = new RegExp("(?=.{6,}).*", "g");
				if (isNameInPwd(pnum, pd)) {
					return 2;
				} else if (isInweek(pd)) {
					return 3;
				} else if (false == enoughRegex.test(pd)) {
					return 1;
				} else if (strongRegex.test(pd)) {
					return -1;
				} else if (mediumRegex.test(pd)) {
					return -1;
				} else {
					return 3;
				}
				return -1;
			},
			generateMixed:function(n){
				var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
				var res = "";
				for (var i = 0; i < n ; i++) {
				    var id = Math.ceil(Math.random() * 35);
				    res += chars[id];
				}
				return res;
			},
			checkisPhone:function(s){
				var regexp = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
				return regexp.test(s);
			},
			closeFloat: function() {
				this.$emit('closefloat');
			},
		}
	}
</script>

<style>
</style>
